// extracted by mini-css-extract-plugin
module.exports = {"loading":"main-page_loading__2Mn-q"};